import { PassUploadJob } from '@app/models/pass-upload-job.model'

const jobFields = Object.keys(new PassUploadJob()).join('\n')

export const GET_PASS_UPLOAD_JOBS = `
query get_pass_upload_jobs($statuses: [String!], $limit: Int) {
    get_pass_upload_jobs(statuses: $statuses, limit: $limit) {
        success
        errorText
        data {
            ${jobFields}
        }
    }
}
`

export const GET_PASS_UPLOAD_JOB = `
query get_pass_upload_job($id: Int!) {
    get_pass_upload_job(id: $id) {
        success
        errorText
        data {
            ${jobFields}
        }
    }
}
`

export const GET_PASS_UPLOAD_JOB_DEFECTS = `
query get_pass_upload_job_defects($id: Int!, $limit: Int) {
    get_pass_upload_job_defects(id: $id, limit: $limit) {
        success
        errorText
        total
        defects {
            row
            reason
            identity
        }
    }
}
`

export const DISMISS_PASS_UPLOAD_JOB = `
mutation dismiss_pass_upload_job($id: Int!) {
    dismiss_pass_upload_job(id: $id) {
        success
        errorText
    }
}
`

export const CANCEL_PASS_UPLOAD_JOB = `
mutation cancel_pass_upload_job($id: Int!) {
    cancel_pass_upload_job(id: $id) {
        success
        errorText
        data {
            ${jobFields}
        }
    }
}
`

export const GET_PASS_UPLOAD_JOB_ERROR_FILE = `
query get_pass_upload_job_error_file($id: Int!) {
    get_pass_upload_job_error_file(id: $id) {
        success
        errorText
        file
        filename
    }
}
`
